import _ from 'lodash'
import vm from '../main'
import { API } from '../config'
import { httpClient as http } from '../services'

const internals = {}

internals.addSegregationPlant = function(segregationPlant) {
    segregationPlant = (({
        cityId,
        plantName,
        plantLocation,        
        user,
        geoloc,
        _id
        
    }) => {
        return {
            cityId,
            plantName,
            plantLocation,            
            user,
            geoloc,
            _id
        }
    })(segregationPlant)

    return vm.$segregationDataRepository
        .create(segregationPlant)
        .then(result => {
            segregationPlant = result.data
            return segregationPlant
        })
        .catch(error => {
            console.error('transportService.createRegion-error:\n', error)
            throw error
        })
}

internals.updateSegregationPlant = function(segregationPlant)
{
    segregationPlant = Object.assign({}, segregationPlant)
    segregationPlant = (({
        cityId,
        plantName,
        plantLocation,
        user,
        _id
        
    }) => {
        return {
            cityId,
            plantName,
            plantLocation,
            user,
            _id
            
        }
    })(segregationPlant)

    return vm.$segregationDataRepository
        .update(segregationPlant._id, segregationPlant)
        .then(result => {
            segregationPlant = result.data
            return segregationPlant
        })
        .catch(error => {
            console.error('transportUpdate.update-error:\n', error)
            throw error
        })
    }

internals.updateSegregationStatus = function(id,status) {
    return http.put(API.SEGREGATION + '/' + id + '/status' + '/' + status)
}

internals.wasteCollectionArea = function(id) {
    return http.get(API.SEGREGATION + '/' + id )
}

internals.segregationSearch = function(params,searchItem) {
    return http
      .get(`/datacity/search?page=${params.page}&limit=${params.limit}&searchString=${searchItem}`)
      .then(result => {
        return result
      })
      .catch(error => {
        console.error('authService.inviteUser-error:\n', error)
        throw error
      })
  }


export default internals


// WEBPACK FOOTER //
// ./src/services/segregation.service.js